import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Toggle, Input } from '../../../GlobalUI';

function OrbeeTrackingForm({
  setOrbeeTracking,
  orbeeTracking,
  setEnabled,
  enabled,
  errorMessage,
}) {
  useEffect(() => {
    if (orbeeTracking?.dealerDomain || orbeeTracking?.provideToken) {
      setEnabled(true);
    }
  }, [orbeeTracking]);

  const onToggleChange = () => {
    if (enabled) {
      setOrbeeTracking({});
    }
    setEnabled(!enabled);
  };

  const handleOnChange = (key, value) => {
    const temp = { ...orbeeTracking };
    temp[key] = value;
    setOrbeeTracking(temp);
  };

  return (
    <div className="setup-config-section">
      <div className="setup-config-header">Orbee Tracking</div>
      <div className="setup-config-content">
        <b>Enable Orbee Tracking</b>
        <Toggle value={enabled} onToggle={onToggleChange} />
        {enabled && (
          <>
            <Input
              label="Dealer Domain*"
              value={orbeeTracking?.dealerDomain}
              onChange={e => handleOnChange('dealerDomain', e.target.value)}
            />
            <Input
              label="Provider Token*"
              value={orbeeTracking?.providerToken}
              onChange={e => handleOnChange('providerToken', e.target.value)}
            />
            <div className="prodigy-input-container-error">
              <p className="prodigy-input-error">{errorMessage}</p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

OrbeeTrackingForm.propTypes = {
  orbeeTracking: PropTypes.object,
  setOrbeeTracking: PropTypes.func,
};

export default OrbeeTrackingForm;
